<template>
    <div class="custom-tooltip"
         :class="{ active: !disabled }">
        <div class="inner">
            <slot></slot>
        </div>
        <div class="tip"
             :class="placement">
            {{ content }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomTooltip',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        placement: {
            type: String,
            default: 'top',
        },
        content: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            large: false,
        }
    },
    computed: {},
    mounted() {},
    beforeDestroy() {},
    methods: {},
}
</script>

<style lang="scss" scoped>
.custom-tooltip {
    position: relative;
    display: inline-block;

    .inner {
        cursor: pointer;
    }

    .tip {
        font-size: 12px;
        line-height: 20px;
        position: absolute;
        visibility: hidden;
        width: max-content;
        padding: 4px 8px;
        transition: all 0.2s;
        white-space: nowrap;
        opacity: 0;
        color: #ffffff;
        border-radius: 8px;
        background-color: #333333;
        z-index: 9;

        &::before {
            position: absolute;
            width: 14px;
            height: 14px;
            content: '';
            background-image: url(@/assets/images/common/tip-icon.svg);
            background-repeat: no-repeat;
            background-position: center;
        }

        &.top-left {
            bottom: 100%;
            left: 0;
            margin: 0 0 10px 0;

            &::before {
                top: 100%;
                left: 0;
                transform: translateX(50%);
                margin: -6px 0 0 0;
            }
        }
        &.top-right {
            bottom: 100%;
            right: 0;
            margin: 0 0 10px 0;

            &::before {
                top: 100%;
                right: 0;
                transform: translateX(-50%);
                margin: -6px 0 0 0;
            }
        }
        &.top {
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            margin: 0 0 10px 0;

            &::before {
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
                margin: -6px 0 0 0;
            }
        }

        &.right {
            top: 50%;
            left: 100%;
            transform: translateY(-50%);
            margin: 0 0 0 10px;

            &::before {
                right: 100%;
                top: 50%;
                transform: translateY(-50%) rotate(90deg);
                margin: 0 -6px 0 0;
            }
        }

        &.bottom {
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            margin: 10px 0 0 0;

            &::before {
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%) rotate(180deg);
                margin: 0 0 -6px 0;
            }
        }

        &.left {
            top: 50%;
            right: 100%;
            transform: translateY(-50%);
            margin: 0 10px 0 0;

            &::before {
                left: 100%;
                top: 50%;
                transform: translateY(-50%) rotate(-90deg);
                margin: 0 0 0 -6px;
            }
        }
    }

    &.active {
        &:hover {
            .tip {
                opacity: 1;
                visibility: visible;
            }
        }
    }
}
</style>
